import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { fileUrl } from "@/lib/api";
import { BRAND } from "@/lib/content";

export const Logo = ({ testid = "site-logo" }) => {
  const { settings } = useSite();
  return (
    <Link to="/" className="flex items-center gap-3 shrink-0" data-testid={testid} aria-label="Tri County Allstars home">
      <img src={settings.logo_url ? fileUrl(settings.logo_url) : BRAND.logo} alt="Tri County Allstars logo" className="h-12 w-auto sm:h-14 drop-shadow-[0_4px_12px_rgba(0,0,0,0.5)]" />
      <span className="leading-none">
        <span className="block font-display text-xl sm:text-2xl font-black uppercase italic tracking-tight">Tri County</span>
        <span className="block font-mono text-[10px] uppercase tracking-[0.4em] text-gold">Allstars</span>
      </span>
    </Link>
  );
};
